
<ng-container *ngIf="(vm$ | async) as vm">
</ng-container>
<div id="map" [style.visibility]="!isLoading ? 'visible' : 'hidden'"> 

</div>
<div style="width:100%;height: 100%;position: fixed;">
    <app-loading-spinner *ngIf="isLoading"></app-loading-spinner>
</div>
